/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ai-event-classification-modal .add-category{border-radius:50%;border:2px solid #41abf3;margin-left:12px;color:#41abf3}.ai-event-classification-modal .edit-wrap{max-height:60vh;overflow-y:auto;overflow-x:hidden}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/ai.event.classification.modal/ai.event.classification.modal.component.scss.ngstyle.js.pre-build-optimizer.js